import React, { useState } from 'react'
import EmployeesService from "../../../services/EmployeesService";
import Select from 'react-select'

const EmployeesForm = ({ userData, modalTitle, setIsOpen, addUser }) => {

    const {
        id: idData,
        firstName: firstNameData,
        lastName: lastNameData,
        email: emailData,
        role: roleData
    } = userData;

    const options = [
        { value: "EMPLOYEE", label: 'Zaposleni' },
        { value: "ASSISTANT", label: 'Asistent' },
        // { value: 15, label: '15 min' },
        // { value: 20, label: '20 min' },
        // { value: 25, label: '25 min' },
        // { value: 30, label: '30 min' },
        // { value: 35, label: '35 min' },
        // { value: 40, label: '40 min' },
        // { value: 45, label: '45 min' },
        // { value: 50, label: '50 min' },
        // { value: 55, label: '55 min' },
        // { value: 60, label: '60 min' },
    ]
    const [firstName, setFirstName] = useState(firstNameData || '');
    const [lastName, setLastName] = useState(lastNameData || '');
    const [email, setEmail] = useState(emailData || '');
    const [role, setRole] = useState(roleData || '');
    const [password, setPassword] = useState('');
    const [hasError, setHasError] = useState(false);


    const formValues = { firstName: firstName, lastName: lastName, email, password, role };


    const isNullOrWhitespace = value => {
        if (!value || value.trim() === '') {
            return true;
        }
        return false;
    }

    const emailRegex = /^[a-zA-Z0-9.!#$%&"*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

    const handleFormSubmit = e => {
        e.preventDefault();
        if (isNullOrWhitespace(firstName) || isNullOrWhitespace(lastName) || isNullOrWhitespace(email) || isNullOrWhitespace(password) || !RegExp(emailRegex).test(email)) {
            setHasError(true);
        } else {
            addUser(userData, formValues, idData)
            setIsOpen(false);
        }
    }

    return (
        <>
            <h3 className='text-center py-2 bg-bluePrimary text-white shadow-md font-medium '>{modalTitle}</h3>
            <form className="w-full mt-6  px-4">
                <div className="input-group mt-3">
                    <label className="font-medium text-xs text-gray-500">Ime</label>
                    <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="input-field" />
                    {hasError && isNullOrWhitespace(firstName) && <span className="input-error">Unesite ime.</span>}
                </div>
                <div className="input-group mt-3">
                    <label className="font-medium text-xs text-gray-500">Prezime</label>
                    <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} className="input-field" />
                    {hasError && isNullOrWhitespace(lastName) && <span className="input-error">Unesite prezime.</span>}
                </div>
                <div className="input-group mt-3">
                    <label className="font-medium text-xs text-gray-500">Email</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" />
                    {hasError && (isNullOrWhitespace(email) || !RegExp(emailRegex).test(email)) && <span className="input-error">Unesite validan email.</span>}
                </div>
                <div className="input-group mt-3">
                    <label className="font-medium text-xs text-gray-500">Šifra</label>
                    <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-field" />
                    {hasError && isNullOrWhitespace(password) && <span className="input-error">Unesite šifru</span>}
                </div>
                <div className="input-group mt-3">
                    <label className="font-medium text-xs text-gray-500">Rola</label>
                    <Select
                        placeholder={'Pretraži...'}
                        onChange={(item) => setRole(item.value)}
                        options={options}
                        classNamePrefix='select'
                    /></div>
                <button type="submit" disabled style={{ display: "none" }} aria-hidden="true"></button>
                <button type="submit" className="button without-icon bg-secondaryGradient mx-auto mt-5" onClick={e => handleFormSubmit(e)}>
                    Sačuvaj
                </button>
            </form>
        </>
    )
}

export default EmployeesForm;
